import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'agendaHideInactiveAppointments';

// Consultas canceladas e faltas continuam na agenda (o backend devolve todos os
// status), mas poluem a visualização de quem só quer ver o que ainda vai
// acontecer. O filtro é do cliente, sobre a mesma lista já carregada, como o
// filtro de sala (useRoomFilter).
const INACTIVE_STATUSES = ['CANCELED', 'NO_SHOW'];

export function useHideInactiveAppointments() {
  const [isHidingInactiveAppointments, setHidingInactiveAppointments] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === 'true',
  );

  // Preserva a escolha ao navegar para /appointment e voltar, como já é feito
  // com a visão, a data e o filtro de sala da agenda.
  useEffect(() => {
    if (isHidingInactiveAppointments) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      return;
    }
    sessionStorage.removeItem(STORAGE_KEY);
  }, [isHidingInactiveAppointments]);

  const filterInactiveAppointments = useCallback(
    (appointments) =>
      isHidingInactiveAppointments
        ? appointments.filter((appointment) => !INACTIVE_STATUSES.includes(appointment.status))
        : appointments,
    [isHidingInactiveAppointments],
  );

  return {
    isHidingInactiveAppointments,
    setHidingInactiveAppointments,
    filterInactiveAppointments,
  };
}
